import React from 'react';
import { FaRegCircle } from "react-icons/fa";
import { filterProjects } from '../data';
import { FaArrowCircleDown } from "react-icons/fa";
import { projectData } from '../data';
import ProjectDetails from '../Components/ProjectDetails';
import { filterProjectsIcons } from '../data';

const Projects = (props) => {

  const currentTechStack=props.currentTechStack;
  const setCurrentTechStack=props.setCurrentTechStack;
  const currentProjects=props.currentProjects;
  const setCurrentProjects=props.setCurrentProjects;

  return (

    <div className='bg-gray-200 w-full min-h-screen project-section-main-container'>

      <div className='max-w-[1200px] mx-auto flex flex-col relative '>          

        {/* project-heading and animating ball */}
        <div className='absolute left-1/2 -translate-x-1/2 sm:-top-10 h-[60%] w-[60%] md:h-1/2 md:w-1/2 z-0'>
          {/* project-page-header */}   
            
          {/* animated shape [reference : https://codepen.io/safiullahahamed/pen/BGxwxE] */}
          <div className="wrapper relative flex justify-center w-full">
            <h2 className='flex text-6xl lg:text-7xl font-bold text-white project-text-shadow absolute top-1/2 -translate-y-1/2'>
                  <span className='text-white'>P</span>
                  <span>rojects</span>
                  <span className='text-sm flex self-end gap-2 ml-1 mb-2 project-heading-dots'>
                    <FaRegCircle className='animate-bounce animating-circle-project-page project-text-circle-shadow rounded-full'/>
                    <FaRegCircle className='animate-bounce project-text-circle-shadow rounded-full'/>
                    <FaRegCircle className='animate-bounce animating-circle-project-page project-text-circle-shadow rounded-full'/>
                  </span>
            </h2>
            <svg className='svg' xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 288 288">
              <linearGradient id="PSgrad_0" x1="70.711%" x2="0%" y1="80.711%" y2="0%">
                <stop offset="0%" stopColor="rgb(95,54,152)" stopOpacity="1" />
                <stop offset="80%" stopColor="rgb(247,109,138)" stopOpacity="1" />
              </linearGradient>
              <path fill="url(#PSgrad_0)">
                  <animate repeatCount="indefinite" attributeName="d" dur="5s" values="M37.5,186c-12.1-10.5-11.8-32.3-7.2-46.7c4.8-15,13.1-17.8,30.1-36.7C91,68.8,83.5,56.7,103.4,45 c22.2-13.1,51.1-9.5,69.6-1.6c18.1,7.8,15.7,15.3,43.3,33.2c28.8,18.8,37.2,14.3,46.7,27.9c15.6,22.3,6.4,53.3,4.4,60.2 c-3.3,11.2-7.1,23.9-18.5,32c-16.3,11.5-29.5,0.7-48.6,11c-16.2,8.7-12.6,19.7-28.2,33.2c-22.7,19.7-63.8,25.7-79.9,9.7 c-15.2-15.1,0.3-41.7-16.6-54.9C63,186,49.7,196.7,37.5,186z; M51,171.3c-6.1-17.7-15.3-17.2-20.7-32c-8-21.9,0.7-54.6,20.7-67.1c19.5-12.3,32.8,5.5,67.7-3.4C145.2,62,145,49.9,173,43.4 c12-2.8,41.4-9.6,60.2,6.6c19,16.4,16.7,47.5,16,57.7c-1.7,22.8-10.3,25.5-9.4,46.4c1,22.5,11.2,25.8,9.1,42.6 c-2.2,17.6-16.3,37.5-33.5,40.8c-22,4.1-29.4-22.4-54.9-22.6c-31-0.2-40.8,39-68.3,35.7c-17.3-2-32.2-19.8-37.3-34.8 C48.9,198.6,57.8,191,51,171.3z; M37.5,186c-12.1-10.5-11.8-32.3-7.2-46.7c4.8-15,13.1-17.8,30.1-36.7C91,68.8,83.5,56.7,103.4,45 c22.2-13.1,51.1-9.5,69.6-1.6c18.1,7.8,15.7,15.3,43.3,33.2c28.8,18.8,37.2,14.3,46.7,27.9c15.6,22.3,6.4,53.3,4.4,60.2 c-3.3,11.2-7.1,23.9-18.5,32c-16.3,11.5-29.5,0.7-48.6,11c-16.2,8.7-12.6,19.7-28.2,33.2c-22.7,19.7-63.8,25.7-79.9,9.7 c-15.2-15.1,0.3-41.7-16.6-54.9C63,186,49.7,196.7,37.5,186z	"/>
              </path>
            </svg>
          </div>      

        </div>

        {/* project-navbar */}
        <nav 
          className='sticky mx-auto top-8 w-fit flex items-center gap-5 text-xl font-medium project-navbar
                      py-2 px-5 mt-16 rounded-full text-[#e84949] z-[19]'>
          {
            filterProjects.map((eachTechStack)=>{
              return <button 
                        className={
                          currentTechStack===eachTechStack.title?
                          'transiton-on-nav-items active':'transiton-on-nav-items'}                        
                        key={eachTechStack.id}
                        onClick={()=>{
                          setCurrentTechStack(eachTechStack.title);
                          setCurrentProjects(projectData[eachTechStack.title])
                          }}>
                          {eachTechStack.title}
                    </button>
            })
          }
        </nav>
        {/* project-navbar-icons */}
        <nav 
          className='hidden sticky mx-auto top-8 w-fit items-center gap-5 project-navbar-icons
                      py-1.5 px-4 mt-10 rounded-full z-[19]'>
          {
            filterProjectsIcons.map((eachTechStack)=>{
              return <button 
                        className={
                          currentTechStack===eachTechStack.title?
                          'transiton-on-nav-items active-icons':'transiton-on-nav-items'}                        
                        key={eachTechStack.id}
                        onClick={()=>{
                          setCurrentTechStack(eachTechStack.title);
                          setCurrentProjects(projectData[eachTechStack.title])
                          }}>
                          {
                            <img
                              className='h-6 project-navbar-image'
                              src={require(`../assets/tech-stack/${eachTechStack.iconPath}`)}
                              alt={eachTechStack.title}
                            />
                          }
                    </button>
            })
          }
        </nav>

        <div className='hidden xl:block mx-auto mt-[31.5%] text-[#e84949] text-2xl animate-bounce'>
          <FaArrowCircleDown />
        </div>

        {/* project-section */}
        <section className='flex flex-col gap-14 sm:gap-14 md:gap-16 lg:gap-28 py-12 mt-[31.5%] xl:mt-[0%] project-card-container'>
          {
            currentProjects.map((eachProject)=>{
            return <ProjectDetails key={eachProject.projectId} {...eachProject}/>
            })
          }
        </section>


      </div>
    </div>
  )
}

export default Projects
